import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ApiServiceService } from '../../services/common/api-service.service';
import { Location } from '@angular/common';
@Component({
  selector: 'app-service-enquiry-list',
  templateUrl: './service-enquiry-list.component.html',
  styleUrls: ['./service-enquiry-list.component.scss']
})
export class ServiceEnquiryListComponent implements OnInit, OnDestroy {

  userId: any;

  enquiries: any[] = [];

  selectedEnquiry: any = null;
  isMobileChatOpen = false;

  replyMessage: string = '';
  @ViewChild('chatContainer')
chatContainer!: ElementRef;

showServiceDetails = false;
refreshInterval:any;

  constructor(
    private apiService: ApiServiceService,
    private location: Location
  ) { }

  ngOnInit(): void {


this.userId =
localStorage.getItem('profileId');


console.log(
"Profile ID:",
this.userId
);


this.loadEnquiries();



this.refreshInterval =
setInterval(()=>{


this.refreshChat();


},5000);



}
  goBack(): void {
  this.location.back();
}

  loadEnquiries() {

  console.log("User ID:", this.userId);

  this.apiService
    .getUserEnquiries(this.userId)
    .subscribe({

      next: (res: any) => {

        console.log("API Response:", res);

        this.enquiries = res.data || [];

        console.log("Enquiries:", this.enquiries);

//         if(this.enquiries.length){

//   this.selectEnquiry(this.enquiries[0]);

// }

      },

      error: (err) => {

        console.log("API Error:", err);

      }

    });

}
refreshChat(){


this.apiService
.getUserEnquiries(this.userId)
.subscribe({

next:(res:any)=>{


const updatedList = res.data || [];


// refresh left side enquiry cards

this.enquiries = updatedList;



// refresh currently opened conversation

if(this.selectedEnquiry){


const updated =
updatedList.find(
(e:any)=>
e._id === this.selectedEnquiry._id
);



if(updated){

this.selectedEnquiry = updated;

}


}


},

error:(err)=>{


console.log(err);


}


});


}
scrollToBottom(){


if(this.chatContainer){


const element =
this.chatContainer.nativeElement;


element.scrollTop =
element.scrollHeight;


}


}

  selectEnquiry(enquiry:any){

  this.selectedEnquiry = enquiry;
  this.isMobileChatOpen = true;
  
setTimeout(()=>{

this.scrollToBottom();

},200);

  // Clear unread messages

  this.apiService
  .markUserRead(enquiry._id)
  .subscribe({

    next:(res:any)=>{

      enquiry.user_unread_count = 0;

    },

    error:(err)=>{

      console.log(err);

    }

  });

}

  sendReply() {

    if (!this.replyMessage.trim()) {

      return;

    }

    const body = {

      sender_type: 'USER',

      sender_id: this.userId,

      message: this.replyMessage

    };

    this.apiService
      .replyServiceEnquiry(
        this.selectedEnquiry._id,
        body
      )
      .subscribe({

        next: (res: any) => {

          this.selectedEnquiry = res.data;

          this.replyMessage = '';

          this.loadEnquiries();

        },

        error: (err) => {

          console.log(err);

        }

      });

  }
  ngOnDestroy(){


if(this.refreshInterval){

clearInterval(this.refreshInterval);

}


}
openServiceDetails(){

  this.showServiceDetails = true;

}


closeServiceDetails(){

  this.showServiceDetails = false;

}
closeMobileChat() {
  this.isMobileChatOpen = false;
  this.selectedEnquiry = null;
}

}